import React, {useEffect} from 'react'
import './Cards.css';
import CardItem from './CardItem';
import locomotiveScroll from 'locomotive-scroll';


function Cards() {


  return (
    <div className='cards' data-scroll data-scroll-container>
      <h1 className="title" data-scroll data-scroll-speed="-1">My Portfolio Web</h1>
      <div className='cards__container' >
      <h3 className="subtitle" >These are some of my most recent web developments.</h3>
        <div className='cards__wrapper' >
          <ul className='cards__items'>
            <CardItem 
              src='images/bajoconsumo.png'
              text=''
              path = "https://www.bajoconsumo.com.ar" 
            />
            <CardItem 
              src='images/ingenierocannabico.png'
              text=''
              path='https://www.ingenierocannabico.com'
            />
            <CardItem 
              src='images/dragonball.png'
              text=''
              path='https://dragon-ball-javascript.vercel.app/'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem 
              src='images/circus.png'
              text=''
              path='https://www.marcodiluch.com'
            />
            <CardItem 
              src='images/opack.png'
              text=''
              path='https://www.opack.com.ar'
            />
            <CardItem 
              src='images/mystik.png'
              text=''
              path='https://www.mystikdesign.com.ar/'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;